import React, { FunctionComponent } from "react";
import {
  Dialog, DialogContent, Grid, Table, TableBody,
  TableHead, TableCell, TableRow, Typography, DialogContentText, IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useCashiersStyles } from "../useCashiersStyles";
import { CashierDetailRow } from "./CashierDetailRow";

interface BillProps {
  cashiersDetails: any;
  openDetails: boolean;
  closeDetails: () => void;
  userData: any;
};

export const CashiersDetailList: FunctionComponent<BillProps> = ({
  cashiersDetails,
  openDetails,
  closeDetails,
  userData
}) => {
  const classes = useCashiersStyles();

  return (
    <Dialog open={openDetails} maxWidth="md" fullWidth={true}>
      <DialogContent>
        <Grid container>
          <Grid item>
            <DialogContentText
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "1.5em",
              }}
            >
              {userData.full_name + " - " + userData.user_code}
            </DialogContentText>
          </Grid>
          <Grid item>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={closeDetails}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ padding: "2em" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Pay Code</TableCell>
                <TableCell align="right">Bill Count</TableCell>
                <TableCell align="right">Deduction Actual Amount</TableCell>
                <TableCell align="right">Deduction System Amount</TableCell>
                <TableCell align="right">Total Actual Amount</TableCell>
                <TableCell align="right">Total System Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cashiersDetails.cashierReconsDetails?.map((row: any) => (
                <CashierDetailRow
                  key={row.id} row={row}
                />
              ))}
              <TableRow>
                <TableCell align="left" className={classes.totalCellStyle}>
                  <Typography className={classes.total}>Grand Total</Typography>
                </TableCell>
                <TableCell className={classes.middleTotalcell} />
                <TableCell className={classes.middleTotalcell} />
                <TableCell className={classes.middleTotalcell} />
                <TableCell className={classes.totalValueCell}>
                  <Typography className={classes.value}>
                    {cashiersDetails !== undefined ?
                      cashiersDetails.cashierReconsDetails[0].grand_total_actual_amount : ""
                    }
                  </Typography>
                </TableCell>
                <TableCell className={classes.totalValueCell}>
                  <Typography className={classes.value}>
                    {cashiersDetails !== undefined ?
                      cashiersDetails.cashierReconsDetails[0].grand_total_system_amount : ""
                    }
                  </Typography>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell align="left" className={classes.totalCellStyle}>
                  <Typography className={classes.total}>Grand Difference</Typography>
                </TableCell>
                <TableCell className={classes.middleTotalcell} />
                <TableCell className={classes.middleTotalcell} />
                <TableCell className={classes.middleTotalcell} />
                <TableCell className={classes.middleTotalcell} />
                <TableCell className={classes.totalValueCell}>
                  <Typography className={classes.value}>
                    {cashiersDetails.grand_difference_amount}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
